'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.DALError = DALError;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function DALError(message, details) {
  var _this = this;

  var extras = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  this.isDalError = true;
  this.message = message;
  this.details = details;
  this.name = 'DALError';
  Object.keys(extras).forEach(function (key) {
    return _this[key] = extras[key];
  });
  var err = Error(message);
  this.stack = err.stack;
}

DALError.prototype = Object.create(Error.prototype);
DALError.prototype.constructor = DALError;

var DALNetworkTimeoutError = (function (_DALError) {
  _inherits(DALNetworkTimeoutError, _DALError);

  function DALNetworkTimeoutError() {
    _classCallCheck(this, DALNetworkTimeoutError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _get(Object.getPrototypeOf(DALNetworkTimeoutError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALNetworkTimeoutError';
  }

  return DALNetworkTimeoutError;
})(DALError);

exports.DALNetworkTimeoutError = DALNetworkTimeoutError;

var DALNotFoundError = (function (_DALError2) {
  _inherits(DALNotFoundError, _DALError2);

  function DALNotFoundError() {
    _classCallCheck(this, DALNotFoundError);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _get(Object.getPrototypeOf(DALNotFoundError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALNotFoundError';
  }

  return DALNotFoundError;
})(DALError);

exports.DALNotFoundError = DALNotFoundError;

var DALBadRequestError = (function (_DALError3) {
  _inherits(DALBadRequestError, _DALError3);

  function DALBadRequestError() {
    _classCallCheck(this, DALBadRequestError);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _get(Object.getPrototypeOf(DALBadRequestError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALBadRequestError';
  }

  return DALBadRequestError;
})(DALError);

exports.DALBadRequestError = DALBadRequestError;

var DALForbiddenError = (function (_DALError4) {
  _inherits(DALForbiddenError, _DALError4);

  function DALForbiddenError() {
    _classCallCheck(this, DALForbiddenError);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _get(Object.getPrototypeOf(DALForbiddenError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALForbiddenError';
  }

  return DALForbiddenError;
})(DALError);

exports.DALForbiddenError = DALForbiddenError;

var DALUnauthorizedError = (function (_DALError5) {
  _inherits(DALUnauthorizedError, _DALError5);

  function DALUnauthorizedError() {
    _classCallCheck(this, DALUnauthorizedError);

    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _get(Object.getPrototypeOf(DALUnauthorizedError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALUnauthorizedError';
  }

  return DALUnauthorizedError;
})(DALError);

exports.DALUnauthorizedError = DALUnauthorizedError;

var DALServerError = (function (_DALError6) {
  _inherits(DALServerError, _DALError6);

  function DALServerError() {
    _classCallCheck(this, DALServerError);

    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _get(Object.getPrototypeOf(DALServerError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALServerError';
  }

  return DALServerError;
})(DALError);

exports.DALServerError = DALServerError;

var DALJsonParseError = (function (_DALError7) {
  _inherits(DALJsonParseError, _DALError7);

  function DALJsonParseError() {
    _classCallCheck(this, DALJsonParseError);

    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _get(Object.getPrototypeOf(DALJsonParseError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALJsonParseError';
  }

  return DALJsonParseError;
})(DALError);

exports.DALJsonParseError = DALJsonParseError;

var DALNoDataError = (function (_DALError8) {
  _inherits(DALNoDataError, _DALError8);

  function DALNoDataError() {
    _classCallCheck(this, DALNoDataError);

    for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _get(Object.getPrototypeOf(DALNoDataError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALNoDataError';
  }

  return DALNoDataError;
})(DALError);

exports.DALNoDataError = DALNoDataError;

var DALNoErrorError = (function (_DALError9) {
  _inherits(DALNoErrorError, _DALError9);

  function DALNoErrorError() {
    _classCallCheck(this, DALNoErrorError);

    for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    _get(Object.getPrototypeOf(DALNoErrorError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALNoErrorError';
  }

  return DALNoErrorError;
})(DALError);

exports.DALNoErrorError = DALNoErrorError;

var DALBadGatewayError = (function (_DALError10) {
  _inherits(DALBadGatewayError, _DALError10);

  function DALBadGatewayError() {
    _classCallCheck(this, DALBadGatewayError);

    for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    _get(Object.getPrototypeOf(DALBadGatewayError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALBadGatewayError';
  }

  return DALBadGatewayError;
})(DALError);

exports.DALBadGatewayError = DALBadGatewayError;

var DALServiceUnavailableError = (function (_DALError11) {
  _inherits(DALServiceUnavailableError, _DALError11);

  function DALServiceUnavailableError() {
    _classCallCheck(this, DALServiceUnavailableError);

    for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }

    _get(Object.getPrototypeOf(DALServiceUnavailableError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALServiceUnavailableError';
  }

  return DALServiceUnavailableError;
})(DALError);

exports.DALServiceUnavailableError = DALServiceUnavailableError;

var DALGatewayTimeoutError = (function (_DALError12) {
  _inherits(DALGatewayTimeoutError, _DALError12);

  function DALGatewayTimeoutError() {
    _classCallCheck(this, DALGatewayTimeoutError);

    for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }

    _get(Object.getPrototypeOf(DALGatewayTimeoutError.prototype), 'constructor', this).apply(this, args);
    this.name = 'DALGatewayTimeoutError';
  }

  return DALGatewayTimeoutError;
})(DALError);

exports.DALGatewayTimeoutError = DALGatewayTimeoutError;
var statusToErrorClass = function statusToErrorClass(status) {
  var defaultType = arguments.length <= 1 || arguments[1] === undefined ? DALError : arguments[1];
  return ({
    400: DALBadRequestError,
    401: DALUnauthorizedError,
    403: DALForbiddenError,
    404: DALNotFoundError,
    500: DALServerError,
    502: DALBadGatewayError,
    503: DALServiceUnavailableError,
    504: DALGatewayTimeoutError
  })[status] || defaultType;
};
exports.statusToErrorClass = statusToErrorClass;